import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormLabel,
  FormControl,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "../MDButton";
import PropTypes from "prop-types";
const DynamicDialog = ({
  open,
  onClose,
  title,
  formData,
  formErrors,
  fields,
  onChange,
  onSave,
}) => {
  const handleFileChange = (name, e) => {
    onChange(name, e.target.files[0]);
  };

  const renderField = (field) => {
    const commonProps = {
      key: field.name,
      fullWidth: true,
      margin: "dense",
      label: field.label,
      value: formData[field.name] || "",
      onChange: (e) => onChange(field.name, e.target.value),
      error: !!formErrors[field.name],
      helperText: formErrors[field.name],
    };

    switch (field.type) {
      case "select":
        return (
          <TextField
            label={field.label}
            margin="dense"
            type="number"
            required={field.required}
            select
            fullWidth
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={formData[field.name] || "0"}
            onChange={(e) => onChange(field.name, e.target.value)}
            error={!!formErrors[field.name]}
            helperText={formErrors[field.name]}
          >
            <option value="" disabled hidden>
              Select {field.label}
            </option>
            {field.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
        );

      case "checkbox":
        return (
          <FormControlLabel
            key={field.name}
            control={
              <Checkbox
                checked={!!formData[field.name]}
                onChange={(e) => onChange(field.name, e.target.checked)}
              />
            }
            label={field.label}
          />
        );

      case "radio":
        return (
          <FormControl key={field.name} component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend">{field.label}</FormLabel>
            <RadioGroup
              row
              value={formData[field.name] || ""}
              onChange={(e) => onChange(field.name, e.target.value)}
            >
              {field.options.map((opt) => (
                <FormControlLabel
                  key={opt.value}
                  value={opt.value}
                  control={<Radio />}
                  label={opt.label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        );
      case "file":
        return (
          <FormControl key={field.name} fullWidth sx={{ mt: 2 }}>
            <FormLabel>{field.label}</FormLabel>
            <Button variant="outlined" component="label">
              Upload File
              <input type="file" hidden onChange={(e) => handleFileChange(field.name, e)} />
            </Button>
            {formData[field.name]?.name && (
              <p style={{ fontSize: "0.8rem", color: "gray" }}>
                Selected: {formData[field.name].name}
              </p>
            )}
          </FormControl>
        );

      default:
        return <TextField type={field.type} {...commonProps} />;
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {title}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#ff4444",
            "&:hover": {
              transform: "scale(1.2)",
              color: "#d32f2f",
              backgroundColor: "rgba(255,255,255,0.2)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>{fields.map(renderField)}</DialogContent>

      <DialogActions>
        <MDButton onClick={onClose} color="error">
          Cancel
        </MDButton>
        <MDButton onClick={onSave} color="info">
          Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};
DynamicDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  formErrors: PropTypes.object,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      required: PropTypes.bool,
      options: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
export default DynamicDialog;
